<template>
  <button
    class="btn mois"
    :disabled="bestPrice == 0"
    :class="{ 'the-best': isTheBest, loading: this.loading }"
    @click="setMois()"
  >
    <p class="mois-intitule mb-0">{{ nomDuMois }}</p>

    <transition
      :duration="{ enter: 500, leave: 500 }"
      name="loading"
      v-on:after-enter="afterLeave"
      v-on:before-enter="beforeEnter"
    >
      <div v-if="!$store.state.isLoading" key="price">
        <p class="price mb-0" v-if="bestPrice">{{ bestPrice + " €" }}</p>
      </div>

      <div v-else key="loader">
        <content-loader></content-loader>
      </div>
    </transition>
  </button>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "BoutonMois",
  props: {
    indexMois: Number
  },
  components: {
    ContentLoader
  },
  data: function() {
    return {
      loading: false
    };
  },
  computed: {
    isTheBest() {
      let meilleurPrix = 99999;

      this.$store.state.prices.forEach(function(year) {
        year.forEach(function(month) {
          meilleurPrix = Math.min(meilleurPrix, month.bestPrice);
        });
      });

      if (this.bestPrice == meilleurPrix) return true;

      return false;
    },

    bestPrice() {
      return this.$store.getters.getBestPriceByMonth(this.indexMois);
    },

    nomDuMois() {
      return this.$store.state.monthsList[this.indexMois];
    }
  },

  methods: {
    setMois() {
      this.$store.dispatch("goToMonth", {
        month: this.indexMois,
        year: this.$store.getters.activeYear
      });
    },
    afterLeave() {
      this.loading = false;
      // done();
    },
    beforeEnter() {
      this.loading = true;
      // done();
    }
  }
};
</script>
